// src\themes\choopar\components\ImageWidget.tsx
import { Heading } from "@/components/ui/Heading";
import Image from "next/image";
import Link from "next/link";

const isVideoUrl = (url?: string) => {
    if (!url) return false;
    return /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(url);
};

export default function ImageWidget({ data }: { data: any }) {
    const image = data?.image || data.thumbnail

    const textAlign = data.direction === 'center' ? 'text-center' : data.direction === 'right' ? 'text-start' : 'text-start';
    const widthMap: Record<string, string> = {
        '1/1': 'col-span-12',
        '1/2': 'col-span-12 md:col-span-6',
        '1/3': 'col-span-12 md:col-span-4',
        '1/4': 'col-span-12 md:col-span-3',
        '2/3': 'col-span-12 md:col-span-8',
        '3/4': 'col-span-12 md:col-span-9',
    };
    const width = widthMap[data.width || '1/1'];

    const aspect = data.orientation === undefined ? "aspect-[16/9]" : data.orientation === "horizontal" ? "aspect-[16/9]" : "aspect-[3/4]"

    const imageBox = (
        <div className={`relative w-full overflow-hidden group ${!data.title && !data.description ? "flex-1 h-full" : ""} ${aspect}`}>
            {image?.url && (
                isVideoUrl(image.url) ? (
                    <video
                        src={image.url}
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="w-full h-full object-cover absolute rounded-md"
                    />
                ) : (
                    <Image
                        src={image.url}
                        alt={image?.name || image?.description || data.title || data.description || 'تصویر'}
                        fill
                        className="object-cover absolute rounded-md transition duration-500 group-hover:scale-105"
                    />
                )
            )}
        </div>
    );

    return (
        <div className={`space-y-4 flex flex-col h-full ${width} ${textAlign}`}>
            {data.link ? (
                <Link href={data.link} className="block">
                    {imageBox}
                </Link>
            ) : (
                imageBox
            )}
            {data.title && (
                <Heading level={2}>
                    {data.title}
                </Heading>
            )}
            {data.description && (
                <p className="text-primary-600 text-sm whitespace-pre-line leading-6">
                    {data.description}
                </p>
            )}
        </div>
    );
}